import React from 'react';
import { Card, Tooltip, Button, Icon } from 'antd';
import { useTranslation } from 'react-i18next';

import { convertImage } from '../../../../../services/contents';
import { truncateText } from '../../../../../services/utils';
import GenerateSkeletonComponent from '../../../../shared/components/GenerateSkeletonComponent';

import Colors from '../../../../../themes/Colors';
const ContentCard = ({ content, origin, isAdded, onAdd, onShowInfo, onDelete }) => {
  const { t } = useTranslation();

  return (
    <Card className="cardContent" key={content.id}>
      <span className="textCard">
        {content.name ? (
          <Tooltip placement="top" title={content.name}>
            {truncateText(content.name, 13)}
          </Tooltip>
        ) : (
          <>&nbsp;</>
        )}
      </span>

      <div className="centerCard">
        {content.file_thumb !== 'pending' ? (
          <img
            src={convertImage(content.file_thumb)}
            onClick={() => onShowInfo(content)}
            className="contentCardImage"
            alt=""
          />
        ) : (
          <GenerateSkeletonComponent count={1} height={70} width={115} />
        )}
      </div>

      <p className="textCard centerCard">
        {content.width} x {content.height}
      </p>

      {origin === 'createCampaign' && (
        <div className="contentCardContent">
          {!isAdded ? (
            <Tooltip title={t('Add content to the campaign')}>
              <Button
                shape="circle"
                disabled={content.file_thumb === 'pending'}
                className="icon-card cardGreen"
                onClick={() => onAdd(content)}
              >
                <Icon type="plus" />
              </Button>
            </Tooltip>
          ) : (
            <Tooltip title={t('Content added in campaign list')}>
              <span style={{ display: 'inline-block' }}>
                <Button
                  shape="circle"
                  disabled
                  className="icon-card cardGreen"
                  style={{ opacity: 1, background: Colors.tintSuccess, borderColor: 'transparent' }}
                >
                  <Icon type="check" style={{ color: '#7CB354' }} />
                </Button>
              </span>
            </Tooltip>
          )}

          <Tooltip title={t('Content information')}>
            <Button
              shape="circle"
              style={{ marginLeft: '6px', marginRight: '6px' }}
              className="icon-card cardBlue"
              onClick={() => onShowInfo(content)}
            >
              {content.type === 'image' && <Icon type="file-image" />}
              {content.type === 'video' && <Icon type="video-camera" />}
              {content.type !== 'video' && content.type !== 'image' && <Icon type="eye" />}
            </Button>
          </Tooltip>

          <Tooltip title={t('Remove ad from the library')}>
            <Button
              shape="circle"
              className="icon-card cardRed"
              onClick={() => onDelete(true, content)}
            >
              <Icon type="delete" />
            </Button>
          </Tooltip>
        </div>
      )}
    </Card>
  );
};

export default ContentCard;
